import { render, staticRenderFns } from "./GroupHeader.vue?vue&type=template&id=ebc0eb54&scoped=true&"
import script from "./GroupHeader.vue?vue&type=script&lang=js&"
export * from "./GroupHeader.vue?vue&type=script&lang=js&"
import style0 from "./GroupHeader.vue?vue&type=style&index=0&id=ebc0eb54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc0eb54",
  null
  
)

export default component.exports